<template>
  <div>     
    <PageHeader
      :page="page"
      :has-return="true"
      @onAdd="goToAddComment()"
      @onReturn="() => $router.back()"
    />
    <FilterManager
      ref="filterManagerRef"
      v-model="filterModel"
      class="filter-manager_extended"
      search-container-class="search-btn"
      :filters="filtersConfig"
      :open-advanced="false"
      @search="onSearchHandler()"
    />
    <custom-separator class="mt-1 mb-4" text="Resultados" />
      <CustomCallout
        :key="index"
        :has-toggle="false"
        class="mt-2"
        v-for="(item, index) in results.data"
      >
        <div class="row mt-2 pb-3">
          <div class="col-md-2">
            <div class="info-text-title">Fecha:</div>
            <p>{{item.date | date}}</p>
          </div>
          <div class="col-md-2">
            <div class="info-text-title">Hora de entrada:</div>
            <p>{{item.date | hour}}</p>
          </div>
          <div class="col-md-3">
            <div class="info-text-title">Propósito:</div>
            <p>{{item.purpose}}</p>
          </div>
          <div class="col-md-3">
            <div class="info-text-title">Nombre de Usuario:</div>
            <p>{{item.userName}}</p>
          </div>
          <div class="col-md-2">
            <div class="info-text-title">Rol Usuario:</div>
            <p>{{ item.userRole}}</p>
            
          </div>
        </div>
      </CustomCallout>
      <CustomResultNotFound
        v-if="results.data?.length<1"
        class="mt-4 row pt-3"
        text="No se ha encontrado resultados"
      />
      <Pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onPageChange"
      />
  </div>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader';
import { ActionButton } from '@/components/common';
import CustomSeparator from "custom-separator";
import { SectionTitle } from '@/components/pei/shared';
import vselect from 'vue-select';
import FilterManager from "FilterManager";
import  { initFilters as _getInitFilters, trackincards as _trackincards } from "@/modules/student/api";
import CustomCallout from 'custom-callout';
import CustomResultNotFound from "custom-result-not-found";
import Pagination from "pagination";
const DEFAULT_PAGE_SIZE = 20;
const initialFilterModel = () => ({
  academicYear: null,
  purpose: null,
});
export default {
  name: 'StudentSearchHistory',
  data() {
    return {
      page: {
        icon: 'fas fa-user',
        title: 'Historial Acceso Expediente del Estudiante',
        routes: ['Inicio', 'Estudiante', 'Historial Acceso Estudiante'],
      },
      filterModel: {
        AcademicYear: null,
        purpose: null,
      },
      AcademicYears: [],
      Categories: [],
      validationMessages: [],
      errorMessage: '',
      filterModel: { ...initialFilterModel() },
      filterOptions: {
        academicYears: [],
        purposes: [], 
      },
      pagination: {
          count: 0,
          currentPage: 1,
          pageCount: 1,
          pageIndex:1,
          totalItemCount: 0,
          pageSize: 10
        },
      results:[]
    };
  },
  components: {
    SectionTitle,
    ActionButton,
    CustomSeparator,
    vselect,
    PageHeader,
    FilterManager,
    CustomResultNotFound,
    CustomCallout,
    Pagination
  },
  computed: {
    filtersConfig() {
      return [
        {
          name: "academicYear",
          component: "CustomDropDown",
          value: this.filterModel.academicYear,
          options: this.filterOptions.academicYears,
          placeholder: "Año Académicos",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-3",
          clearable: true,
          validations: this.academicYearValidation
        },
        {
          name: "purpose",
          component: "CustomDropDown",
          value: this.filterModel.purpose,
          options: this.filterOptions.purposes,
          placeholder: "Propositos",
          fieldName: "name",
          fieldKey: "id",
          class: "col-12 col-md-3",
          clearable: true
        },
      ];
    },
    studentSieId() {
      return this.$store.getters["$_student/SelectedStudent"]?.studentId;
    },
  },
  methods: {
    async getInitFilters() {
      const { data } = await _getInitFilters({
        studentSieId: isNaN(this.studentSieId)
          ? null : Number(this.studentSieId)
      });

      this.filterOptions = {
        ...this.filterOptions,
        ...data
      };
    },
    async onSearchHandler(){
      let params ={
        academicYearId:this.filterModel.academicYear?.id,
        cardId:this.filterModel.purpose?.id,
        studentSieId: isNaN(this.studentSieId) ? null : Number(this.studentSieId),
        pageIndex:this.pagination.pageIndex,
        pageSize:this.pagination.pageSize
      }
      this.fetchResults(params);
    },
    async loadInfo(){
      let params ={
        studentSieId: isNaN(this.studentSieId) ? null : Number(this.studentSieId),
        pageIndex:1,
        pageSize:10
      }
      this.fetchResults(params);
    },
    async onPageChange(page) {
      let params ={
        academicYearId:this.filterModel?.academicYear?.id,
        cardId:this.filterModel.purpose?.id,
        studentSieId: isNaN(this.studentSieId) ? null : Number(this.studentSieId),
        pageIndex:page,
        pageSize:this.pagination.pageSize
      }
      this.fetchResults(params);
    },
    async fetchResults(params) {
     let { data } = await _trackincards(params);
      this.results = data;
      this.pagination = {
          ...this.pagination,
          totalItemCount: this.results.totalItemCount,
          pageCount: this.results.pageCount,
          currentPage: this.results.currentPage,
          count: this.results.count
        };
    },

  },
  async mounted() {
   await this.getInitFilters();
   await this.loadInfo();
  },
};
</script>

<style scoped>
  .block-spacing {
    margin-bottom: 30px;
  }

  .block-spacing >>> .invalid {
    position: absolute;
    font-size: 13px;
    margin-left: 5px;
  }

  .btnwidth {
    width: 150px;
    margin-top: 20px;
  }
  .container-search{
    border-radius: 5px;
    background-color: #f4f6f3;
    padding: 20px;
  }
</style>
